import React from 'react';
import type { FilterableEntityTableRefAPI } from './types';

export type PaginatedEntityTableContextValues = FilterableEntityTableRefAPI & {
    /**
     * Replace the free-text search term from outside the filter bar — for a cell that offers
     * "search for this" on something it renders.
     *
     * The term lives in EntityFilters' own state rather than the filter slice, so this is the way
     * to reach it. Setting it queues the same debounced search that typing does, which is why
     * there is no need to call `search()` afterwards (and why doing so would race the state update).
     */
    setSearchTerm: (term: string) => void;
};

/**
 * EntityFilters' search-term setter, as handed to the owning table. `silent` puts the term in the
 * box without searching for it: the table already has, when it restores a term from the URL.
 */
export type SearchTermSetter = (term: string, options?: { silent?: boolean }) => void;

export const PaginatedEntityTableContext = React.createContext<PaginatedEntityTableContextValues>({
    search: () => {},
    setSearchTerm: () => {},
});
